const color_scale = [
    "#E53935", "#D81B60", "#8E24AA", "#5E35B1", "#303F9F", "#1976D2", "#039BE5", "#00BCD4", "#00796B", "#4CAF50",
    "#CDDC39", "#F57F17", "#FFB300", "#FFA726", "#D84315", "#795548", "#9E9E9E", "#607D8B"
]

export { color_scale }